import styled from "styled-components/macro";

export const Img = styled.img``;
